// extracted by mini-css-extract-plugin
export default {"award":"Award_award__q1kmf","awardIcon":"Award_awardIcon__xAKYy"};